export default __webpack_public_path__ + "static/eoapi_veda-dbe9e74651ff7ddc5b7cb815493bcb87.png";